<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="550px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="form.companyName" placeholder="请输入公司名称" />
      </el-form-item>
      <el-form-item label="公司Logo" prop="companyLogo">
        <div>
          <div style="font-size: 12px; color: #909399">推荐图片尺寸为：170*170，支持JPG、PNG格式，图片大小不超过2M</div>
           <el-upload
            class="logo-uploader"
            :action="''"
            :http-request="handleUpload"
            :show-file-list="false"
            :before-upload="beforeUpload"
          >
            <img v-if="form.companyLogoUrl" :src="form.companyLogoUrl" class="logo" />
            <i v-else class="el-icon-plus logo-uploader-icon"></i>
            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="所属行业" prop="industry">
        <el-input v-model="form.industry" placeholder="请输入所属行业" />
      </el-form-item>
      <el-form-item label="公司规模" prop="scale">
        <el-select v-model="form.scale" placeholder="请选择公司规模">
          <el-option
            v-for="option in scaleOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-form-item>
      
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { companyRecruit } from "@/services";
import { upload } from "@/services";

export default {
  name: "CompanyCreateEditDialog",
  props: {
    value: Boolean,
    company: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        companyName: "",
        industry: "",
        scale: "",
        companyLogo: "",
        companyLogoUrl: "",
      },
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          { max: 50, message: "公司名称不能超过50字", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请输入所属行业", trigger: "blur" },
          { max: 20, message: "行业不能超过20字", trigger: "blur" },
        ],
        scale: [{ required: true, message: "请选择公司规模", trigger: "blur" }],
      },
      scaleOptions: [
        { label: "0-20人", value: 0 },
        { label: "20-99人", value: 1 },
        { label: "100-499人", value: 2 },
        { label: "500-999人", value: 3 },
        { label: "1000-9999人", value: 4 },
        { label: "10000人以上", value: 5 },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isEdit() {
      return !!this.company.id;
    },
    dialogTitle() {
      return this.isEdit ? '编辑公司' : '创建公司';
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (this.isEdit) {
          this.form = { ...this.company };
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        companyName: "",
        industry: "",
        scale: "",
        companyLogo: "",
        companyLogoUrl: "",
      };
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不超过2M");
        return false;
      }
      return true;
    },
    async handleUpload({ file }) {
      try {
        const { ok, data } = await upload.file(file, 'image');
        if (ok) {
          this.form.companyLogo = data.data;
          this.form.companyLogoUrl = data.url;
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传失败");
        }
      } catch (error) {
        console.error("上传失败", error);
        this.$message.error("上传失败");
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.resetForm();
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let res;
            if (this.isEdit) {
              res = await companyRecruit.updateCompany(this.form);
            } else {
              res = await companyRecruit.createCompany(this.form);
            }
            this.$message.success(this.isEdit ? "编辑成功" : "创建成功");
            this.dialogVisible = false;
            this.resetForm();
            this.$emit("confirm");
          } catch (err) {
            console.error("操作失败", err);
            this.$message.error("操作失败");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.logo-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.logo-uploader:hover {
  border-color: #409eff;
}

.logo-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.logo {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
</style>